import axios from "axios";

export const __DBPATH__ = "http://yoo.devletec.info/wp-json/yoo/v1";
export const __ROOTPATH__ = "http://yoo.devletec.info";
export const INITIALPRICE = 21;

export const getData = async url => {
  try {
    const options = {
      url,
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8"
      }
    };

    const response = await axios(options);

    return response.data;
  } catch (error) {
    console.log(error, "error trying get data");
  }
};

export const getWizardData = async (match, location) => {  
  let wizardDataURL;
  let wizardData;
  if (location) {
    wizardDataURL = `${__DBPATH__}/wizard/${location.pathname.replace('/', '')}`;
    wizardData = await getData(wizardDataURL);
  } else {
    wizardDataURL = `${__DBPATH__}/wizard/${match.params.wizardId}`;
    wizardData = await getData(wizardDataURL);
  }

  return wizardData;
};
